import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';
import LocationAndCurrencyInfoComponent from '../../../../../../../components/location-and-currency-info';
import { SotyBadge } from 'src/areas/store/components/soty-badge-link/soty-badge';
import { H4Text } from '@prisjakt/ui/text/variants';
import { ViewSize } from '../../types';

export const StyledExpandedInfo = styled.div`
  padding: ${layout.measurements.spacing100};
`;

export const StyledFirstSection = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
`;

export const StyledStoreLink = styled(H4Text)`
  display: flex;
  align-items: center;
  margin-bottom: ${layout.measurements.spacing025};
  > svg > path {
    fill: currentColor;
  }
`;

export const StyledGeneralInfo = styled.div`
  grid-area: 2 / 1 / 3 / 3;
  display: flex;
  flex-direction: column;
  > h4,
  > div > h4 {
    margin-top: ${layout.measurements.spacing100};
  }
`;

export const StyledLocationAndCurrencyInfo = styled(
  LocationAndCurrencyInfoComponent
)`
  align-items: baseline;
`;

interface IStyledSotyBadge {
  $viewSize?: ViewSize;
}

export const StyledSotyBadge = styled(SotyBadge)<IStyledSotyBadge>`
  margin: ${layout.measurements.spacing025};
  align-items: normal;

  ${props =>
    props.$viewSize === ViewSize.SMALL &&
    css`
      max-width: 88px;
    `}
`;
